var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 29V26.3333C10 24.9188 10.4917 23.5623 11.3668 22.5621C12.242 21.5619 13.429 21 14.6667 21H19.3333C20.571 21 21.758 21.5619 22.6332 22.5621C23.5083 23.5623 24 24.9188 24 26.3333V29M12 12C12 13.3261 12.5268 14.5979 13.4645 15.5355C14.4021 16.4732 15.6739 17 17 17C18.3261 17 19.5979 16.4732 20.5355 15.5355C21.4732 14.5979 22 13.3261 22 12C22 10.6739 21.4732 9.40215 20.5355 8.46447C19.5979 7.52678 18.3261 7 17 7C15.6739 7 14.4021 7.52678 13.4645 8.46447C12.5268 9.40215 12 10.6739 12 12ZM2 5.25C2 4.38805 2.34241 3.5614 2.9519 2.9519C3.5614 2.34241 4.38805 2 5.25 2H28C28.862 2 29.6886 2.34241 30.2981 2.9519C30.9076 3.5614 31.25 4.38805 31.25 5.25V28C31.25 28.862 30.9076 29.6886 30.2981 30.2981C29.6886 30.9076 28.862 31.25 28 31.25H5.25C4.38805 31.25 3.5614 30.9076 2.9519 30.2981C2.34241 29.6886 2 28.862 2 28V5.25Z",
    stroke: "#E9EAE8",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnUser);
export default __webpack_public_path__ + "static/media/btnUser.17db3eb549d7911a036b05c8cd1fa686.svg";
export { ForwardRef as ReactComponent };